/**
 * The header's "See tokens" chip (Mumms admins only): shows the token split
 * and cost columns in the MAIA grids. One value for the whole page, so the
 * tile, its expanded copy and MAIA Chats' patient dialog agree; it resets on
 * reload.
 */
import create from 'zustand';

import { useMaiaChatAgentContext } from '../context';

type ShowCostState = {
  showCost: boolean;
  setShowCost: (value: boolean) => void;
};

const useShowCostStore = create<ShowCostState>((set) => ({
  showCost: false,
  setShowCost: (value) => set({ showCost: value }),
}));

export const setShowCost = (value: boolean) =>
  useShowCostStore.getState().setShowCost(value);

export const useShowCost = (): [boolean, (value: boolean) => void] => [
  useShowCostStore((s) => s.showCost),
  setShowCost,
];

/**
 * Whether the grids show the token split and cost columns: the chip is on
 * and the user is a Mumms admin (the chip only shows to them).
 */
export const useCostColumnsShown = (): boolean => {
  const { isMummsAdmin } = useMaiaChatAgentContext();
  const showCost = useShowCostStore((s) => s.showCost);
  return Boolean(isMummsAdmin) && showCost;
};
